import {Component, OnInit} from '@angular/core';
import { CookieService } from 'ngx-cookie';

@Component({
  selector: 'ngx-one-column-layout',
  styleUrls: ['./one-column.layout.scss'],
  template: `
    <nb-layout windowMode>
      <nb-layout-header fixed>
        <ngx-header></ngx-header>
      </nb-layout-header>

      <nb-sidebar class="menu-sidebar" tag="menu-sidebar" responsive *ngIf="logged">
        <ngx-custom-sidebar-channel></ngx-custom-sidebar-channel>
      </nb-sidebar>

      <nb-layout-column>
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>

      <nb-layout-footer fixed>
        <ngx-footer></ngx-footer>
      </nb-layout-footer>
    </nb-layout>
  `,
})
export class OneColumnLayoutComponent implements OnInit {

  constructor(
    public cookieService: CookieService,

  ) { }
  email = '';
  logged = false;

  ngOnInit() {
    this.email = this.cookieService.get('email');
    if (this.email === '' || this.email === undefined || !this.email) {
      this.logged = false;
    } else {
      this.logged = true;
    }
  }
}
